/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrgEmailPrefResponse } from "../models/OrgEmailPrefResponse";
import type { OrgEmailPrefUpdate } from "../models/OrgEmailPrefUpdate";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class OrgEmailPrefsService {
  /**
   * Update Organization Email Preferences
   * Update an organization's email preferences by its ID using specified attributes
   * within OrgEmailPrefUpdate to update the database.
   * @returns OrgEmailPrefResponse Successful Response
   * @throws ApiError
   */
  public static updateOrgEmailPrefs({
    prefId,
    requestBody,
  }: {
    prefId: number;
    requestBody: OrgEmailPrefUpdate;
  }): CancelablePromise<OrgEmailPrefResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/org_email_prefs/{pref_id}",
      path: {
        pref_id: prefId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        422: `Validation Error`,
        500: `Internal Server Error`,
      },
    });
  }
}
